import _objectSpread from "/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectSpread";
import _objectWithoutProperties from "/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
import classNames from 'classnames';
import * as React from 'react';
import { useMemo } from 'react';
import { useUncontrolled } from 'uncontrollable';
import { useBootstrapPrefix } from './ThemeProvider';
import AccordionBody from './AccordionBody';
import AccordionButton from './AccordionButton';
import AccordionCollapse from './AccordionCollapse';
import AccordionContext from './AccordionContext';
import AccordionHeader from './AccordionHeader';
import AccordionItem from './AccordionItem';
import { jsx as _jsx } from "react/jsx-runtime";
var Accordion = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var _useUncontrolled = useUncontrolled(props, {
    activeKey: 'onSelect'
  }),
      _useUncontrolled$as = _useUncontrolled.as,
      Component = _useUncontrolled$as === void 0 ? 'div' : _useUncontrolled$as,
      activeKey = _useUncontrolled.activeKey,
      bsPrefix = _useUncontrolled.bsPrefix,
      className = _useUncontrolled.className,
      onSelect = _useUncontrolled.onSelect,
      flush = _useUncontrolled.flush,
      alwaysOpen = _useUncontrolled.alwaysOpen,
      controlledProps = _objectWithoutProperties(_useUncontrolled, ["as", "activeKey", "bsPrefix", "className", "onSelect", "flush", "alwaysOpen"]);

  var prefix = useBootstrapPrefix(bsPrefix, 'accordion');
  var contextValue = useMemo(function () {
    return {
      activeEventKey: activeKey,
      onSelect: onSelect,
      alwaysOpen: alwaysOpen
    };
  }, [activeKey, onSelect, alwaysOpen]);
  return /*#__PURE__*/_jsx(AccordionContext.Provider, {
    value: contextValue,
    children: /*#__PURE__*/_jsx(Component, _objectSpread({
      ref: ref
    }, controlledProps, {
      className: classNames(className, prefix, flush && "".concat(prefix, "-flush"))
    }))
  });
});
Accordion.displayName = 'Accordion';
export default Object.assign(Accordion, {
  Button: AccordionButton,
  Collapse: AccordionCollapse,
  Item: AccordionItem,
  Header: AccordionHeader,
  Body: AccordionBody
});